/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { MerchantDetailsParentComponent } from "../merchant-details-parent.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService } from "../../../services";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import { Chargeback, Merchant } from "../../../models";

@Component({
  selector: "app-chargebacks",
  templateUrl: "./chargebacks.component.html"
})
export class ChargebacksComponent extends MerchantDetailsParentComponent implements OnInit {
  faUsd = faDollarSign;
  showChargebacks = true;
  chargebacks!: Chargeback[];
  chargebackProperties = [
    "Chargeback Date",
    "Chargeback Transaction ID",
    "Original Transaction ID",
    "Chargeback Amount",
    "Chargeback Fee",
    "Total Charged to Merchant",
    "Status",
    "Issuer"
  ];
  searchingForChargeBacks = true;
  collectingChargeBack = false;
  @Input("merchant") merchant!: Merchant;
  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }
  ngOnInit(): void {
    this.merchantService.getChargeBacks(this.merchant.id).subscribe(
      (chargebacks) => {
        this.chargebacks = this.sortChargeBacksByDateDesc(chargebacks);
        this.searchingForChargeBacks = false;
      },
      (error) => {
        this.notificationService.error(error.error);
        this.searchingForChargeBacks = false;
      }
    );
  }

  sortChargeBacksByDateDesc(chargebacks: Chargeback[]) {
    return chargebacks.sort((a, b) => {
      return new Date(b.chargebackDate).getTime() - new Date(a.chargebackDate).getTime();
    });
  }

  receiveCBEvent(value: boolean) {
    this.collectingChargeBack = value;
  }

  receiveChargeBack(value: Chargeback) {
    this.chargebacks.unshift(value);
    this.collectingChargeBack = false;
  }
}
